
(function(){

	'use strict';

	if($('.smp-search #sort')) {
        $('.smp-search #sort').on('change', function() {
            var url = window.location.href;
            if(url.indexOf('sort=') > -1) {
                var current = url.match(/sort=([^\&]*)/);
                window.location.href = url.replace(current[0], 'sort=' + this.value);
            } else {
                window.location.href += '&sort=' + this.value;
            }
        });
    }
}());
